import { render } from "./SlotList.vue?vue&type=template&id=edb2e9c2&scoped=true"
import script from "./SlotList.vue?vue&type=script&lang=js"
export * from "./SlotList.vue?vue&type=script&lang=js"

import "./SlotList.vue?vue&type=style&index=0&id=edb2e9c2&scoped=true&lang=css"
import "./SlotList.vue?vue&type=style&index=1&id=edb2e9c2&lang=css"

import exportComponent from "../../../../../../../../../../../Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb2e9c2"]])

export default __exports__